import ApiService from '@/utils/ApiService'

export default {
  namespaced: true,
  state: {
    isLoadingWarehouseItem: false,
    warehouseItemsOptions: [],
    promotionsOptions: [],
    devicesOptions: [],
    packages: [],
    packagesView: {},
    isLoadingPackages: false
  },
  getters: {
    getPackageById: state => id => {
      if (id) {
        return state.packages.find(item => item['@id'] === id)
      }
    },
    getPackagesView: state => state.packagesView,
    getIsLoadingPackages (state) {
      return state.isLoadingPackages
    },
    getPackages: state => state.packages,
    getWarehouseItems (state) {
      return state.warehouseItemsOptions.map(option => {
        return { value: option['@id'], text: option.name }
      })
    },
    getWarehouseItemById: state => id => {
      if (id) {
        return state.warehouseItemsOptions.find(warehouseItemsOptions => warehouseItemsOptions['@id'] === id)
      }
    },
    getPromotions (state) {
      return state.promotionsOptions.map(option => {
        return { value: option['@id'], text: option.title }
      })
    },
    getPromotionById: state => id => {
      if (id) {
        return state.promotionsOptions.find(promotionsOptions => promotionsOptions['@id'] === id)
      }
    },
    getDevices (state) {
      return state.devicesOptions.map(option => {
        return { value: option['@id'], text: option.idDeviceModel.idDeviceType.title + ' ' + option.idDeviceModel.idDeviceBrand.brandTitle + ' (' + option.serialNumber + ')' }
      })
    }
  },
  mutations: {
    reset (state) {
      state.isLoadingWarehouseItem = false
      state.warehouseItemsOptions = []
      state.promotionsOptions = []
      state.devicesOptions = []
      state.packages = []
      state.packagesView = {}
      state.isLoadingPackages = false
    },
    setPackagesView (state, payload) {
      state.packagesView = payload
    },
    toggleLoadingPackages (state) {
      state.isLoadingPackages = !state.isLoadingPackages
    },
    setPackages (state, payload) {
      state.packages = payload
    },
    setPromotionsOptions (state, payload) {
      state.promotionsOptions = payload
    },
    setDevicesOptions (state, payload) {
      state.devicesOptions = payload
    },
    setWarehouseItems (state, payload) {
      state.warehouseItemsOptions = payload
    }
  },
  actions: {
    async fetchWarehouseItemsOptions ({ commit }, params) {
      let baseParams = { pagination: false }
      Object.assign(baseParams, params)
      const response = await new ApiService('e_x_s_b_items', baseParams).getResults()
      commit('setWarehouseItems', await response.items)
    },
    async fetchPromotions ({ commit }, params) {
      let baseParams = { pagination: false }
      Object.assign(baseParams, params)
      const response = await new ApiService('e_x_a_b_promotions', baseParams).getResults()
      commit('setPromotionsOptions', await response.items)
    },
    async fetchDevices ({ commit }, params) {
      let baseParams = { pagination: false }
      Object.assign(baseParams, params)
      const response = await new ApiService('e_x_c_m_devices', baseParams).getResults()
      commit('setDevicesOptions', await response.items)
    },
    async fetchPackages ({ commit }, link = 'e_x_a_b_packages') {
      commit('toggleLoadingPackages')
      const response = await new ApiService(link).getResults()
      commit('toggleLoadingPackages')
      commit('setPackages', await response.items)
      commit('setPackagesView', await response.view)
    }
  }
}
